import React from "react";
import "./Toggle.scss";

interface ToggleProps {
  label: string;
  isOn: boolean;
  onToggle: () => void;
}

const Toggle = ({ label, isOn, onToggle }: ToggleProps) => {
  return (
    <div className="toggle-container" aria-label={`${label} Toggle`}>
      <div
        className={`toggle ${isOn ? "toggle-on" : "toggle-off"}`}
        onClick={onToggle}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onToggle();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <div className="toggle-switch"></div>
      </div>
      <div className="toggle-label">{label}</div>
    </div>
  );
};

export default Toggle;
